var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4738 0.926515C24.9631 0.414794 25.7562 0.414795 26.2455 0.926516L42.0179 17.4241C42.5071 17.9358 42.5071 18.7655 42.0179 19.2772L38.4501 23.0091C37.9609 23.5208 37.1676 23.5208 36.6784 23.0091L20.906 6.51151C20.4168 5.99978 20.4168 5.17012 20.906 4.65839L24.4738 0.926515Z",
    fill: "#34A9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4042 17.838C42.8936 18.3497 42.8936 19.1794 42.4042 19.6911L26.2884 36.5479C25.7992 37.0596 25.0061 37.0596 24.5168 36.5479L20.9489 32.8161C20.4597 32.3044 20.4597 31.4747 20.9489 30.963L37.0648 14.1062C37.554 13.5945 38.3472 13.5945 38.8364 14.1062L42.4042 17.838Z",
    fill: "#34A9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95821 0.926515C5.44743 0.414794 6.24063 0.414795 6.72985 0.926516L22.5023 17.4241C22.9915 17.9358 22.9915 18.7655 22.5023 19.2772L18.9345 23.0091C18.4453 23.5208 17.652 23.5208 17.1628 23.0091L1.39036 6.51151C0.901131 5.99978 0.90113 5.17012 1.39036 4.65839L4.95821 0.926515Z",
    fill: "#34A9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8886 17.838C23.3778 18.3497 23.3778 19.1794 22.8886 19.6911L6.77283 36.5479C6.28359 37.0596 5.4904 37.0596 5.00117 36.5479L1.43333 32.8161C0.944098 32.3044 0.9441 31.4747 1.43333 30.963L17.5492 14.1062C18.0384 13.5945 18.8316 13.5945 19.3208 14.1062L22.8886 17.838Z",
    fill: "#34A9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility6);
export default __webpack_public_path__ + "static/media/utility6.c95f80c06a9d373aad812e3a6b0c6f3f.svg";
export { ForwardRef as ReactComponent };